import { render, staticRenderFns } from "./BannerPromoCourse.vue?vue&type=template&id=448a1d8a&"
import script from "./BannerPromoCourse.vue?vue&type=script&lang=js&"
export * from "./BannerPromoCourse.vue?vue&type=script&lang=js&"
import style0 from "./BannerPromoCourse.vue?vue&type=style&index=0&id=448a1d8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports